
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gnn/sumber-belajar",
      function () {
        return require("private-next-pages/gnn/sumber-belajar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gnn/sumber-belajar"])
      });
    }
  